/**
 * Inspection Series datatable service.
 *
 * Calls the existing /inspection_series/listing.json endpoint using the
 * serialized URLSearchParams produced by seriesStateSerializer.
 *
 * The endpoint contract is unchanged — this service is a thin HTTP adapter.
 * Errors are re-thrown (not swallowed) so they propagate to React Query's
 * error state.
 *
 * Scope is encoded in the URLSearchParams as building_id or account_id
 * (not via URL path segments) matching how the Ruby datatable reads them.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { serializeSeriesRequest } from '../adapters/seriesStateSerializer';
const SERIES_LISTING_PATH = '/inspection_series/listing.json';
/**
 * Fetches one page of inspection series from the server.
 * Throws on HTTP error so React Query surfaces it as `error` state.
 */
export function fetchInspectionSeries(state) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = serializeSeriesRequest(state);
        const response = yield api.get(SERIES_LISTING_PATH, {
            params
        });
        return response.data;
    });
}
